import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { usePublicApiService } from "contexts/PublicApiServiceProvider";

export const useAddProductToCompany = ({
  companyId,
}: {
  companyId: string;
}) => {
  const publicApi = usePublicApiService();
  return useMutation<unknown, AxiosError, { productKey: string }>({
    mutationFn: ({ productKey }) =>
      publicApi.addProductToCompany({ companyId, productKey }),
  });
};
